import { render, staticRenderFns } from "./createHorario.vue?vue&type=template&id=33c8f8f2&"
import script from "./createHorario.vue?vue&type=script&lang=js&"
export * from "./createHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports